module.exports = __webpack_public_path__ + "img/2.3761292e.png";